import _ from 'lodash';
import store from '../../../store';
import { OVERVIEW_PANEL_GET_CURRENT, OVERVIEW_PANEL_IS_VISIBLE } from '../../../store/modules/overview-panel/types';

import worldMap from '../../core/map';
import { pinBuilder } from '../../core/map/pinBuilder';
import templates from '../../core/templates';
import ColorBrewer from '../../core/tools/colorbrewer';
import environment from '../../environment';
import { notify, NOTIFY_TYPE } from '../../shared/notify';
import Leaflet from '../Leaflet';
// import 'mapbox.js';

const LayerControls = (name) => require('../../controls').get(name);

const get = (name, currentMap = worldMap.getCurrent()) => {
  return require('../index').default.get(name, currentMap);
};

const name = 'CustomersAfterSales';

class CustomersAfterSalesLayer {
  constructor(currentMap) {
    const mapId = +currentMap._id;

    const clusterImage = new Image();
    clusterImage.src = `${environment.get('IMAGES_HOST')}/icon_marker_customers.png`;

    const colors = {
        black: 'rgba(0, 0, 0, 1)',
        yellow: 'rgba(255, 193, 7, 1)',
        blue: 'rgba(30, 136, 229, 1)',
        orange: 'rgba(255, 102, 0, 1)',
        purple: 'rgba(103, 58, 183, 1)',
        red: 'rgba(229, 57, 53, 1)',
        teal: 'rgba(0, 137, 123, 1)',
        pink: 'rgba(216, 27, 96, 1)',
        brown: 'rgba(140, 86, 75, 1)',
        gray: 'rgba(200, 200, 200, 1)',
    };

    const getUniqValues = (values) => {
      if (values.length === 0) {
        return [];
      }

      return values.reduce((acc, curr) => {
        if (!acc.some(x => x.value === curr.value)) {
          acc.push(curr);
        }
        return acc;
      }, []);
    };

    const clusterTemplate = (cluster) => {
      const data = {
        percent: [],
        colors: [],
        value: cluster.getChildCount()
      };

      let total = 0;
      const categories = {};

      const values = getUniqValues(get(name, currentMap).options.symbology.values);
      const order = _.map(_.range(0, values.length), i => 0);

      _.forEach(values, (v, i) => {
        order[i] = v.value;
        data.colors.push(colors[v.style.color]);
      });

      _.forEach(cluster.getAllChildMarkers(), (marker) => {
        if (marker.feature) {
          total++;
          const prop = marker.feature.properties.sid;
          categories[prop] = categories[prop] + 1 || 1;
        }
      });

      if (total > 0) {
        _.forEach(order, id => data.percent.push(((categories[id] || 0) / total) || 0));
      }

      return pinBuilder.create.pin.imageWithValue(data, clusterImage);
    };

    const onSuccess = (res) => {
      if (!res.features.length) {
        notify(NOTIFY_TYPE.LOG, 'Não há dados para o período selecionado');
      }

      return res;
    };

    const onComplete = (res) => {
      if (store.getters[OVERVIEW_PANEL_GET_CURRENT] === name && store.getters[OVERVIEW_PANEL_IS_VISIBLE] && LayerControls(name).getControls(mapId).button.overview.enable) {
        LayerControls(name).toggleOverview();
      }
    };

    return new Leaflet.D3Layer({
      map: currentMap,
      remote: null,
      showAll: true,
      autofocus: false,
      uniqueField: 'Id',
      controlRange: 30,
      incremental: true,
      type: 'cluster',
      above: true,
      done: onComplete,
      success: onSuccess,
      popup: {
        trigger: 'mouseover',
        clusterTemplate(features, layer) {
          if (worldMap.getZoom() < 8) return;

          const layerType = LayerControls(name).getControls(mapId).buttonGroup.layerType.type;
          if (layerType === 'decluster') {
            this.options.offset = L.point(0, -16);
          } else {
            this.options.offset = L.point(0, -50);
          }
          return new Promise((resolve, reject) => {
            const total = _.size(features);

            const data = _(features)
              .groupBy('feature.properties.sid')
              .map((v, k) => {
                const style = _.find(get(name, currentMap).options.symbology.values, (s) => String(s.value) === k).style;
                const text = _.first(v).feature.properties.n;
                return {
                  id: k,
                  value: _.size(v),
                  percent: _.size(v) / total,
                  text,
                  color: colors[style.color]
                };
              })
              .orderBy(x => x.percent)
              .reverse()
              .reduce((res, val, index) => {
                res.push(val);
                return res;
              }, []);

            const template = $(templates('map-layer-clients-cluster-popup-alt', ({ clients: data })));

            setTimeout(() => {
              $('#map-popup-chart').kendoChart({
                title: {
                  text: ''
                },
                dataSource: { data: _.filter(data, d => parseFloat(d.value) > 0) },
                seriesColors: _.map(data, d => d.color),
                seriesDefaults: {
                  labels: {
                    position: 'center',
                    visible: true,
                    background: 'transparent',
                    format: '{0}',
                    font: 'bold 10px "Roboto Condensed", sans-serif',
                    color: '#FFF'
                  }
                },
                theme: 'bootstrap',
                chartArea: {
                  height: 140,
                },
                legend: {
                  position: 'right',
                  labels: {
                    font: '10px "Roboto Condensed", sans-serif'
                  }
                },
                series: [{
                  type: 'pie',
                  field: 'value',
                  categoryField: 'text'
                }]
              });
            }, 300);

            resolve(template);
          });
        },
        options: {
          offset: L.point(0, -16),
          closeButton: false,
          autoclose: true
        },
        single: true
      },
      legend: {
        title: 'Lojas',
        text: (property) => {
          return property.n;
        },
        icon: (property) => {
          const values = get(name, currentMap).options.symbology.values;
          const store = _.find(values, p => p.value === property.sid);
          return store && store.style.icon.iconUrl;
        }
      },
      symbology: {
        cluster: {
          template: clusterTemplate
        },
        heat: {
          theme: ColorBrewer.getHeatColors(ColorBrewer.RED)
        },
        type: 'uniq',
        property: 'sid',
        values: []
      }
    });
  }
}

export default CustomersAfterSalesLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/AfterSales/CustomersAfterSalesLayer.js